import { Box, ButtonBase } from "@mui/material";
import Attachment from "./Attachment";
import ImageUploadButton from "./ImageUploadButton";
import { Add } from "@mui/icons-material";
import AlertDialog from "components/AlertDialog";
import { useState } from "react";
import { useLanguage } from "contexts/language.context";

export default function Attachments({
  readOnly,
  lazy = false,
  attachments,
  onRemoveAttachment,
  onAddAttachments,
  reason,
}) {
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const { label } = useLanguage();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0.5,
        flexWrap: "wrap",
        pt: 1.5,
        mb: -0.5,
      }}
    >
      <AlertDialog
        open={!!alertDialogOpen}
        setOpen={setAlertDialogOpen}
        title={label("delete-alert-title")}
        content={label("delete-alert-message")}
        onOk={async () => {
          await onRemoveAttachment?.(
            alertDialogOpen.attachment,
            alertDialogOpen.index,
          );
          setAlertDialogOpen(false);
        }}
      />
      {attachments.map((attachment, index) => {
        return (
          <Attachment
            readOnly={readOnly}
            lazy={lazy}
            key={"Task attachment: " + attachment.id}
            attachment={attachment}
            reason={reason}
            onRemoveAttachment={
              onRemoveAttachment
                ? () => {
                    setAlertDialogOpen({ attachment, index });
                  }
                : null
            }
          />
        );
      })}

      {!readOnly ? (
        <ImageUploadButton
          onChange={(files) => {
            onAddAttachments(files);
          }}
        >
          <ButtonBase
            sx={(theme) => ({
              height: "80px",
              width: "80px",
              overflow: "hidden",
              borderRadius: "8px",
              position: "relative",
              backgroundColor: theme.palette.divider,
            })}
          >
            <Add fontSize="medium" />
          </ButtonBase>
        </ImageUploadButton>
      ) : null}
    </Box>
  );
}
